import React from 'react'
import { Route, Routes } from 'react-router-dom'
import HomePageGoogle from '../Components/HomePageGoogle/HomePageGoogle'
import Thanks from '../Tools/Thanks/Thanks'
import BookAnAppointment from '../Components/BookAnAppointment/BookAnAppointment'
import ThanksContact from '../Tools/ThanksContact/ThanksContact'
import PrivacyPolicy from '../Tools/PrivacyPolicy/PrivacyPolicy'
import TermsAndConditions from '../Tools/TermsAndConditions/TermsAndConditions'
import HomePageGoogleChimney from '../Components/HomePageGoogleChimney/HomePageGoogleChimney'
import HomePageGoogleAirDuct from '../Components/HomePageGoogleAirDuct/HomePageGoogleAirDuct'
import ServicesAll from '../Components/ServicesAll/ServicesAll'
import ServicesPage from '../Components/ServicesPage/ServicesPage'
import HomePageCity from '../Components/HomePageCity/HomePageCity'
import SiteMap from '../Tools/SiteMap/SiteMap'
import NotFound from '../Tools/NotFound/NotFound'

export default function Main({ CitiePhone, CitiesData, navigateTo, locationsMain, locationsMain2Chimney, WebSitePages }) {

    return (
        // <div>
        <Routes>
            <Route path="/" element={<HomePageGoogle locationsMain={locationsMain} CitiesData={CitiesData} CitiePhone={CitiePhone} navigateTo={navigateTo} />} />
            {/* SEO landing pages (full nav + footer) — organic search lands here */}
            <Route path="/chimney/*" element={<HomePageGoogleChimney locationsMain2Chimney={locationsMain2Chimney} CitiesData={CitiesData} CitiePhone={CitiePhone} navigateTo={navigateTo} />} />
            <Route path="/airduct/*" element={<HomePageGoogleAirDuct locationsMain={locationsMain} CitiesData={CitiesData} CitiePhone={CitiePhone} navigateTo={navigateTo} />} />
            {/* Ads landing pages (limited nav). Campaigns route to /local/{service}/* by ad type. */}
            <Route path="/local/chimney/*" element={<HomePageGoogleChimney locationsMain2Chimney={locationsMain2Chimney} CitiesData={CitiesData} CitiePhone={CitiePhone} navigateTo={navigateTo} />} />
            <Route path="/local/airduct/*" element={<HomePageGoogleAirDuct locationsMain={locationsMain} CitiesData={CitiesData} CitiePhone={CitiePhone} navigateTo={navigateTo} />} />
            {/* Services */}
            <Route path="/services" element={<ServicesAll CitiePhone={CitiePhone} />} />
            <Route path="/service/:service" element={<ServicesPage CitiePhone={CitiePhone} CitiesData={CitiesData} locationsMain2Chimney={locationsMain2Chimney} navigateTo={navigateTo} />} />
            <Route path="/service/:service/:city" element={<ServicesPage CitiePhone={CitiePhone} CitiesData={CitiesData} locationsMain2Chimney={locationsMain2Chimney} navigateTo={navigateTo} />} />
            {/* City pages */}
            <Route path="/city/:city" element={<HomePageCity CitiePhone={CitiePhone} CitiesData={CitiesData} locationsMain2Chimney={locationsMain2Chimney} navigateTo={navigateTo} />} />
            <Route path="/book/*" element={<BookAnAppointment CitiesData={CitiesData}  CitiePhone={CitiePhone} />} />
            <Route path="/thanks" element={<Thanks CitiePhone={CitiePhone} navigateTo={navigateTo} />} />
            <Route path="/thankscontact" element={<ThanksContact CitiePhone={CitiePhone} navigateTo={navigateTo} />} />
             {/* Privacy Policy */}
             <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions/>} />
            {/* SiteMap */}
            {["/sitemaps", "/sitemap", "/widgets"].map((path, index) =>
                <Route path={path} key={index} element={<SiteMap CitiePhone={CitiePhone} WebSitePages={WebSitePages} />} />
            )}
            <Route path="/sitemap/:id" element={<SiteMap CitiePhone={CitiePhone} WebSitePages={WebSitePages} />} />
            {/* 404 */}
            <Route path="*" element={<NotFound CitiePhone={CitiePhone} />} />
        </Routes>
        // </div>
    )
}
